<template>
  <div class="mx-3 my-3 pb-4">
    <div class="grid grid-cols-12 gap-4">
      <div class="flex flex-col col-span-2" style="cursor: pointer;">
        <div
          :class="currentRoute === 'upload-limit' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('upload-limit')"
        >
          <div class="flex">
            <div>Upload limit</div>
          </div>
        </div>
        <div
          :class="currentRoute === 'keywords' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('keywords')"
        >
          <div class="flex">
            <div>Exempt keywords</div>
          </div>
        </div>
        <div
          :class="currentRoute === 'audit' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('audit')"
        >
          <div class="flex">
            <div>Keyword audit</div>
          </div>
        </div>
        <div
          :class="currentRoute === 'blocked' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('blocked')"
        >
          <div class="flex">
            <div>Blocked requests</div>
          </div>
        </div>
        <div
          :class="currentRoute === 'sms-gateway' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('sms-gateway')"
        >
          <div class="flex">
            <div>SMS gateway</div>
          </div>
        </div>
      </div>
      <div class="col-span-10">
        <GatewayUploadLimit v-if="currentRoute === 'upload-limit'" ref="uploadRef" />
        <ExemptKeywordsList v-if="currentRoute === 'keywords'" ref="keywordsRef" />
        <ExemptKeywordsAudit v-if="currentRoute === 'audit'" ref="auditRef" />
        <GatewayBlockedRequests v-if="currentRoute === 'blocked'" ref="blockedRef" />
        <SmsGateway v-if="currentRoute === 'sms-gateway'" ref="smsGatewayRef" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref } from "vue";
import ExemptKeywordsAudit from "./ExemptKeywordsAudit.vue";
import ExemptKeywordsList from "./ExemptKeywordsList.vue";
import GatewayBlockedRequests from "./GatewayBlockedRequests.vue";
import GatewayUploadLimit from "./GatewayUploadLimit.vue";
import SmsGateway from "./SmsGateway.vue";

type TabChild = { refresh?: () => void } | null;

const currentRoute = ref("upload-limit");
const uploadRef = ref<TabChild>(null);
const keywordsRef = ref<TabChild>(null);
const auditRef = ref<TabChild>(null);
const blockedRef = ref<TabChild>(null);
const smsGatewayRef = ref<TabChild>(null);

const refreshActiveTab = () => {
  if (currentRoute.value === "upload-limit") uploadRef.value?.refresh?.();
  else if (currentRoute.value === "keywords") keywordsRef.value?.refresh?.();
  else if (currentRoute.value === "audit") auditRef.value?.refresh?.();
  else if (currentRoute.value === "blocked") blockedRef.value?.refresh?.();
  else if (currentRoute.value === "sms-gateway") smsGatewayRef.value?.refresh?.();
};

const select = (route: string) => {
  currentRoute.value = route;
  nextTick(() => refreshActiveTab());
};

const refresh = () => {
  refreshActiveTab();
};

defineExpose({ refresh });
</script>
